// extracted by mini-css-extract-plugin
export default {"signupBlock":"signupBlock-ZV4yb","signupBlockContainer":"signupBlockContainer-ytj0-","bglayer":"bglayer-2RRtY","signupBlockMobile":"signupBlockMobile-1335z"};